// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
const enum MiniCommonIcons {
    Accept = 'Accept',
    AccessLogo = 'AccessLogo',
    Add = 'Add',
    Archive = 'Archive',
    Attach = 'Attach',
    Back = 'Back',
    Blocked = 'Blocked',
    Calendar = 'Calendar',
    Cancel = 'Cancel',
    Checkbox = 'Checkbox',
    CheckboxComposite = 'CheckboxComposite',
    CheckMark = 'CheckMark',
    ChevronDown = 'ChevronDown',
    ChevronLeft = 'ChevronLeft',
    ChevronRight = 'ChevronRight',
    ChevronUp = 'ChevronUp',
    CircleAdditionSolid = 'CircleAdditionSolid',
    CircleFill = 'CircleFill',
    CircleRing = 'CircleRing',
    CityNext = 'CityNext',
    Clock = 'Clock',
    Cloud = 'Cloud',
    CompletedSolid = 'CompletedSolid',
    Contact = 'Contact',
    Delete = 'Delete',
    Download = 'Download',
    Edit = 'Edit',
    Encryption = 'Encryption',
    Error = 'Error',
    Event = 'Event',
    EventAccepted = 'EventAccepted',
    EventDateMissed12 = 'EventDateMissed12',
    EventDeclined = 'EventDeclined',
    EventTentative = 'EventTentative',
    ExcelDocument = 'ExcelDocument',
    FabricFolder = 'FabricFolder',
    FavoriteStar = 'FavoriteStar',
    FavoriteStarFill = 'FavoriteStarFill',
    FileImage = 'FileImage',
    Forward = 'Forward',
    GlobalNavButton = 'GlobalNavButton',
    Help = 'Help',
    Inbox = 'Inbox',
    Info = 'Info',
    LyncLogo = 'LyncLogo',
    Mail = 'Mail',
    OfficeLogo = 'OfficeLogo',
    OneNoteLogo = 'OneNoteLogo',
    OpenInNewWindow = 'OpenInNewWindow',
    OutlookLogo = 'OutlookLogo',
    Page = 'Page',
    PDF = 'PDF',
    People = 'People',
    Photo2Remove = 'Photo2Remove',
    POI = 'POI',
    PowerPointDocument = 'PowerPointDocument',
    ProtectedDocument = 'ProtectedDocument',
    PublisherLogo = 'PublisherLogo',
    RadioBtnOff = 'RadioBtnOff',
    RadioBtnOn = 'RadioBtnOn',
    RecurringEvent = 'RecurringEvent',
    Refresh = 'Refresh',
    RemoveEvent = 'RemoveEvent',
    Room = 'Room',
    Save = 'Save',
    Search = 'Search',
    Send = 'Send',
    Settings = 'Settings',
    StatusErrorFull = 'StatusErrorFull',
    TextDocument = 'TextDocument',
    ToDoLogoOutline = 'ToDoLogoOutline',
    UnknownSolid = 'UnknownSolid',
    Video = 'Video',
    VisioDocument = 'VisioDocument',
    WordDocument = 'WordDocument',
    ZipFolder = 'ZipFolder',
}

export default MiniCommonIcons;
